import React, { useContext, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { TBanquetForm } from "../../types";
import * as Contexts from "../../../../contexts";
import { config, Translater } from "../../../../config";
import { InputsWrap, Wrapper } from "./styled";

export const Terms = () => {
  const { language } = useContext(Contexts.LanguageContext);
  const { watch, setValue, register } = useFormContext<TBanquetForm>();

  const banketMenu = watch("banketMenu");
  const banketTerms = watch("banketTerms");

  useEffect(() => {
    register("banketMenu");
    register("banketTerms");
  }, [register]);

  const getFileUrl = (file: File | string | undefined) => {
    if (!file) return "";
    if (typeof file === "string") {
      return file.startsWith("http")
        ? file
        : `${config.serverURL}public/${file}`;
    }
    return URL.createObjectURL(file);
  };

  const renderFileLink = (file: File | string | undefined, label: string) => {
    if (!file || typeof file !== "string") return null;
    const href = getFileUrl(file);
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        <span role="img" aria-label="document">
          📄
        </span>{" "}
        {label}
      </a>
    );
  };

  return (
    <Wrapper>
      {" "}
      <InputsWrap>
        <p>{Translater.Landings.Banquet.menu[language.slug]}</p>
        <span>
          <input
            name="banketMenu"
            className="file-input"
            type="file"
            accept=".pdf"
            onChange={(e) =>
              setValue("banketMenu", e.target.files?.[0], {
                shouldValidate: true,
                shouldDirty: true,
              })
            }
          />
          {renderFileLink(
            banketMenu,
            Translater.Landings.Banquet.viewMenu[language.slug]
          )}
        </span>
      </InputsWrap>
      <InputsWrap>
        <p>{Translater.Landings.Banquet.banquetTerms[language.slug]}</p>
        <span>
          <input
            name="banketTerms"
            className="file-input"
            type="file"
            accept=".pdf"
            onChange={(e) =>
              setValue("banketTerms", e.target.files?.[0], {
                shouldValidate: true,
                shouldDirty: true,
              })
            }
          />
          {renderFileLink(
            banketTerms,
            Translater.Landings.Banquet.viewTerms[language.slug]
          )}
        </span>
      </InputsWrap>
    </Wrapper>
  );
};
